import { differenceInCalendarDays, startOfDay } from 'date-fns'

export type TrialComputed =
  | { state: 'NO_TRIAL' }
  | { state: 'ACTIVE'; daysLeft: number; pct: number }
  | { state: 'EXPIRED'; daysSince: number }

export function computeTrial(o: {
  trialStartedAt: string | null
  trialEndsAt: string | null
  trialIncluded?: number
  messageUsage?: { included: number; used: number } | null
  now?: string
}): TrialComputed {
  if (!o.trialStartedAt || !o.trialEndsAt) return { state: 'NO_TRIAL' }
  const today = startOfDay(o.now ? new Date(o.now) : new Date())
  const ends = startOfDay(new Date(o.trialEndsAt))
  if (ends > today) {
    const daysLeft = differenceInCalendarDays(ends, today)
    const included = o.messageUsage?.included ?? o.trialIncluded ?? 150
    const used = o.messageUsage?.used ?? 0
    const pct = Math.min(100, Math.round((used / Math.max(1, included)) * 100))
    return { state: 'ACTIVE', daysLeft, pct }
  }
  const daysSince = differenceInCalendarDays(today, ends)
  return { state: 'EXPIRED', daysSince }
}
